function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback, useState } from 'react';
import Log from '@deephaven/log';
import { PersistentStateProvider } from "./PersistentStateContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
var log = Log.module('DashboardPanelWrapper');
export function DashboardPanelWrapper(_ref) {
  var glContainer = _ref.glContainer,
    children = _ref.children;
  var handleDataChange = useCallback(data => {
    glContainer.setPersistedState(data);
  }, [glContainer]);
  var _glContainer$getConfi = glContainer.getConfig(),
    persistedState = _glContainer$getConfi.persistedState;

  // Use a state initializer so we can warn once if the persisted state is invalid
  var _useState = useState(() => {
      if (persistedState != null && !Array.isArray(persistedState)) {
        log.warn("Persisted state is type ".concat(typeof persistedState, ". Expected array. Setting to empty array."));
        return [];
      }
      return persistedState !== null && persistedState !== void 0 ? persistedState : [];
    }),
    _useState2 = _slicedToArray(_useState, 1),
    initialPersistedState = _useState2[0];
  return /*#__PURE__*/_jsx(PersistentStateProvider, {
    initialState: initialPersistedState,
    onChange: handleDataChange,
    children: children
  });
}
export default DashboardPanelWrapper;
//# sourceMappingURL=DashboardPanelWrapper.js.map